module.exports = __webpack_public_path__ + "img/2_2.a982d81e.png";